import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'buscarEntreFechas'
})
export class BuscarEntreFechasPipe implements PipeTransform {

  transform(value: any, fechaInicio:any, fechaFin:any): any {
    if(!value) return []
    if(!fechaInicio || !fechaFin) return value
    return value.filter((item)=>{
      //(dateNow >= dateStart && dateNow <= dateEnd)
      /*console.log("Fecha Inicio -->", fechaInicio)
      let fecha = new Date(item.fecha)
      let inicio = new Date(fechaInicio.year, fechaInicio.month-1,fechaInicio.day)
      let fin = new Date(fechaFin.year, fechaFin.month-1,fechaFin.day)
      console.log("Fecha Tarea-->",fecha.getFullYear()+'-'+(fecha.getMonth()+1)+'-'+fecha.getDate(),
      "Fecha Inicio", inicio.getFullYear()+'-'+(inicio.getMonth()+1)+'-'+inicio.getDate(),
      "Fecha Fin", fin.getFullYear()+'-'+(fin.getMonth()+1)+'-'+fin.getDate())
      console.log("resultado",item.fecha >= new Date(fechaInicio.year, fechaInicio.month-1,fechaInicio.day).getTime() && item.fecha <= new Date(fechaFin.year, fechaFin.month-1,fechaFin.day).getTime()  )*/
      return  item.fecha >= new Date(fechaInicio.year, fechaInicio.month-1,fechaInicio.day-1).getTime() && item.fecha <= new Date(fechaFin.year, fechaFin.month-1,fechaFin.day).getTime()  
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filters/buscar-entre-fechas.pipe.ts